// extracted by mini-css-extract-plugin
export default {"form":"f_qHTOa8","mobile":"mobile","row":"hpvDU7tP","codeSender":"ex1r5fD2","field":"YEA9dPcZ","phoneConfirm":"ALui3iG2"};